//import { PnkAjax } from '../api/pnk-ajax';
import { PnkAjax } from '../pnk-react/ajax/pnk-ajax';

export function LoginUser(store, data, SuccessCallBackFunc) {
    console.log(data);
    let loader = { isLoader: false, containecccrId: 'testpnk', size: 'small' };
    return PnkAjax(store).Post('users/login.json').ExtraData(data).AttachLoader(loader).OnSuccess(SuccessCallBackFunc).Do();
}

export function LoginByNumber(store, userData, SuccessCallBackFunc) {
    let loader = { isLoader: false, containerId: 'testpnk', size: 'small' };
    return PnkAjax(store).Post('call/loginbynumber/json').ExtraData(userData).AttachLoader(loader).OnSuccess(SuccessCallBackFunc).Do();
}

export function AddNewUser(store, data, token, SuccessCallBackFunc) {
  let loader = { isLoader: false, containerId: 'testpnk', size: 'small' };
  return PnkAjax(store).Post('users/new.json').ExtraData(data).AttachLoader(loader).AddHeader({ 'x-access-token': token }).OnSuccess(SuccessCallBackFunc).Do();
}
export function UpdateUser(store, data, token, SuccessCallBackFunc) {
  let loader = { isLoader: false, containerId: 'testpnk', size: 'small' };
  return PnkAjax(store).Put('users/update.json').ExtraData(data).AttachLoader(loader).AddHeader({ 'x-access-token': token }).OnSuccess(SuccessCallBackFunc).Do();
}
export function GetUserList(store, data, token, SuccessCallBackFunc) {
  let loader = { isLoader: false, containerId: 'testpnk', size: 'small' };
  return PnkAjax(store).Post('users/search.json').ExtraData(data).AttachLoader(loader).AddHeader({ 'x-access-token': token }).OnSuccess(SuccessCallBackFunc).Do();
}

export function UploadFile(store, data, token, SuccessCallBackFunc) {
  let loader = { isLoader: false, containerId: 'testpnk', size: 'small' };
  return PnkAjax(store).Post('users/fileupload.json').ExtraData(data).AttachLoader(loader).AddHeader({ 'x-access-token': token }).OnSuccess(SuccessCallBackFunc).Do();
}

